import React, { useState } from "react";
import {
  ChevronDown,
  ChevronUp,
  Check,
  Shield,
  Landmark,
  Handshake,
  BadgeCheck,
  TrendingUp,
  Globe,
} from "lucide-react";
import Option from "../../images/bus.jpg";

const faqs = [
  {
    question:
      "What makes Urban Nest Properties a trusted partner for land investments in Bangalore?",
    answer:
      "Urban Nest is backed by deep real estate knowledge, legal expertise, and local market experience, ensuring your investment is secure and profitable.",
    icon: <Shield className="w-5 h-5 text-purple-600" />,
  },
  {
    question: "Are the plots offered by Urban Nest legally approved?",
    answer:
      "Yes, we offer 100% BMRDA approved plots in Bangalore, ensuring a legally secure purchase for your peace of mind.",
    icon: <BadgeCheck className="w-5 h-5 text-emerald-600" />,
  },
  {
    question: "Where are your projects located?",
    answer:
      "We have projects in fast-growing locations like Chikka Madure and Nelamangala, providing you with excellent appreciation potential.",
    icon: <Globe className="w-5 h-5 text-blue-600" />,
  },
  {
    question: "How does Urban Nest ensure a smooth buying process?",
    answer:
      "We handle reliable documentation and fast registration to save your time and avoid legal hassles.",
    icon: <Landmark className="w-5 h-5 text-amber-600" />,
  },
  {
    question: "Are there any hidden charges?",
    answer:
      "No hidden costs. Transparent pricing is our commitment to every customer.",
    icon: <Check className="w-5 h-5 text-green-600" />,
  },


];

export default function UrbanNestFAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <div className="bg-gradient-to-br from-slate-50 to-slate-100 py-12 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* FAQ Section */}
          <div className="space-y-6">
            <div className="mb-8">
              <h2 className="text-2xl md:text-4xl lg:text-4xl font-bold text-[#1B0727] mb-4">
                Why Choose Urban Nest Properties?
              </h2>
              <p className="text-lg text-slate-600">
                Your trusted partner for secure and profitable land investments
                in Bangalore
              </p>
              <div className="w-24 h-1.5 bg-gradient-to-r from-amber-400 to-amber-600 rounded-full mt-4"></div>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 ${
                    openIndex === index
                      ? "ring-2 ring-amber-400"
                      : "hover:shadow-lg"
                  }`}
                >
                  <div
                    className="flex items-center justify-between p-5 cursor-pointer"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="flex items-start space-x-4">
                      <div className="p-2 bg-slate-100 rounded-lg">
                        {faq.icon}
                      </div>
                      <h3 className="text-lg font-semibold text-slate-800">
                        {faq.question}
                      </h3>
                    </div>
                    {openIndex === index ? (
                      <ChevronUp className="w-5 h-5 text-amber-600" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-slate-500" />
                    )}
                  </div>
                  {openIndex === index && (
                    <div className="px-5 pb-5 pt-2 animate-fadeIn">
                      <div className="pl-14">
                        <p className="text-slate-600">{faq.answer}</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Side Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-400 to-purple-500 rounded-3xl opacity-20 blur-lg"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
              <img
                src={Option}
                alt="Urban Nest Properties - Why Choose Us" title="Urban Nest Properties - Why Choose Us"
                loading="lazy"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            </div>

            {/* Stats Section */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              {[
                { value: "100%", label: "Legal Approval" },
                { value: "15+", label: "Years Experience" },
                { value: "500+", label: "Happy Clients" },
                { value: "0", label: "Hidden Charges" },
                
              ].map((stat, index) => (
                <div
                  key={index}
                  className="bg-white p-4 rounded-xl shadow-md text-center hover:shadow-lg transition-shadow"
                >
                  <p className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600">
                    {stat.value}
                  </p>
                  <p className="text-slate-600 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
